import styles from './BrokersCell.module.scss';

interface BrokersCellProps {
  brokers: string[];
}

export const BrokersCell = ({ brokers }: BrokersCellProps) => (
  <div className={styles.brokers}>
    {brokers.map((broker) => (
      <span key={broker}>{broker}</span>
    ))}
  </div>
);
